<template>
  <div id="containerStep3">
    <vs-prompt title="Add 'Others' Option" @cancel="val = ''" @accept="acceptAlert" :active.sync="showOtherForm">
      <div class="con-exemple-prompt">
        <span>Enter Other Name</span>
        <vs-input v-model="otherModel" class="mt-3 w-full" />
      </div>
    </vs-prompt>
    <vs-prompt title="Add Supplier Option" @accept="addSupplier" :active.sync="showSupplierForm">
      <div class="con-exemple-prompt">
        <!-- center this -->

        <vx-card title="Select Company" class="text-center">
          <companyRadio v-model="supplierModel.compId" />
        </vx-card>

        <span>Enter Supplier Number</span>
        <vs-input v-model="supplierModel.supplierNo" class="mt-3 w-full" />

        <span>Enter Supplier Name</span>
        <vs-input v-model="supplierModel.name" class="mt-3 w-full" />
      </div>
    </vs-prompt>

    <div class="vx-row align-center">
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card title="Select Supplier" class="text-center">
          <template slot="actions">
            <feather-icon @click="showSupplierForm = true" icon="PlusIcon"
              svgClasses="w-6 h-6 text-primary"></feather-icon>
          </template>
          <selectField :endPoint="endPoint" :defaultValue="getGr.supplier" v-model="getGr.supplier"
            :tableParams="suppliersTableDetails" />

        </vx-card>

        <vx-card title="Select Others" class="text-center">
          <template slot="actions">
            <feather-icon @click="showOtherForm = true" icon="PlusIcon" svgClasses="w-6 h-6 text-primary"></feather-icon>
          </template>
          <selectField :endPoint="endPoint" :defaultValue="getGr.others" v-model="getGr.others"
            :tableParams="othersTableDetails" />
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <div class="vx-row align-center">
          <vs-input size="large" label="Supplier Document No." name="supplierDocNo" v-model="getGr.supplierDocNumber"
            class="m-5 input-center w-full" />
          <label class="ml-5 mt-5"> Remarks</label>
          <vs-textarea class="ml-5" v-model="getGr.remarks" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import selectField from './selectField.vue'
import { axiosMixin } from "@/mixin/axiosMixin.js";
import companyRadio from './companyRadio.vue';
import { mapGetters } from "vuex";
export default {
  mixins: [axiosMixin],
  components: {
    selectField,
    companyRadio
  },
  data() {
    return {
      otherModel: "",

      othersEndpoint: "others",
      suppliersEndpoint: "suppliers",
      selectedOthers: "",
      othersTableDetails: {
        tableName: "others",
        columnId: "id",
        columnName: "name",
      },
      showOtherForm: false,
      showSupplierForm: false,
      selectedSupplier: null,
      endPoint: "getSelectData",

      suppliersTableDetails: {
        tableName: "suppliers",
        columnId: "id",
        columnName: "name",
      },
      supplierDocNo: '',
      remarks: '',

      supplierModel: {
        name: "",
        compId: "",
        supplierNo: ""
      },
      remarks: '',
    }
  },
  methods: {
    startLoading() {
      this.disableSubmitBtn = false;
      this.$vs.loading({
        container: "#containerStep3",
        scale: 0.6
      });
    },
    stopLoading() {
      this.disableSubmitBtn = true;
      this.$vs.loading.close("#containerStep3 > .con-vs-loading");
    },
    selectSupplier(value) {
      this.selectedSupplier = value;
    },
    acceptAlert() {
      this.aronPostPut(
        this.othersEndpoint,
        'add',
        { name: this.otherModel },
        ""
      )
        .then(response => {
          //this.$router.push("/" + this.getCallBack).catch(() => {});

          if (this.operation == "add") {
            this.$emit("addnew", {
              response: response.data,
              view: "list"
            });
          } else {
            this.$emit("updateRow", {
              response: response.data,
              view: "view"
            });
          }
          this.stopLoading();
        })
        .catch(error => {
          console.error("error from : update profile_edit. reason:", error);
          this.stopLoading();
        });
    }, addSupplier() {
      this.aronPostPut(
        this.suppliersEndpoint,
        'add',
        this.supplierModel,
        ""
      )
        .then(response => {
          //this.$router.push("/" + this.getCallBack).catch(() => {});
          this.stopLoading();
        })
        .catch(error => {
          console.error("error from : update profile_edit. reason:", error);
          this.stopLoading();
        });
    },

  },
  watch: {
    selectedSupplier(value) {
      this.$emit('input', value);
    },
  },
  computed: {
    ...mapGetters({
      getGr: "main/getGr",
    })
  }
};
</script>
